import { Pressable, StyleSheet, type StyleProp, type ViewStyle } from 'react-native'
import React, { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'

type SendMessageButtonProps = Omit<ComponentProps<typeof Pressable>, 'style'> & {
  style?: StyleProp<ViewStyle>
}

const SendMessageButton = ({ onPress, style, ...rest }: SendMessageButtonProps) => {
  return (
    <Pressable onPress={onPress} {...rest} style={[styles.button, style]}>
      <ArrowIcon />
    </Pressable>
  )
}

const ArrowIcon = (props: ComponentProps<typeof Svg>) => (
  <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <Path
      d="M10.4419 17.5129C10.1979 17.757 9.80214 17.757 9.55806 17.5129C9.31398 17.2688 9.31398 16.8731 9.55806 16.629L15.5622 10.6249L2.92893 10.6249C2.58375 10.6249 2.30393 10.3451 2.30393 9.99988C2.30393 9.6547 2.58375 9.37488 2.92893 9.37488L15.5622 9.37488L9.55806 3.37076C9.31398 3.12668 9.31398 2.73095 9.55806 2.48687C9.80214 2.24279 10.1979 2.24279 10.4419 2.48687L17.955 9.99988L10.4419 17.5129Z"
      fill="white"
    />
  </Svg>
)

export default SendMessageButton

const styles = StyleSheet.create({
  button: {
    width: 40,
    height: 32,
    borderRadius: 24,
    backgroundColor: 'black',
    alignItems: 'center',
    justifyContent: 'center'
  }
})
